module.exports = __webpack_public_path__ + "static/media/mr.a46829f1.svg";